<p-toast></p-toast>

<div class="table">
  <!-- Column Settings Sidebar -->
  <p-drawer   
    styleClass="settingsSidebar"   
    [transitionOptions]="'300ms'"   
    [(visible)]="showSettingsSidebar"   
    [modal]="false"  
    (onShow)="updatedSelectedColFields()"
    position="right"  
    [showCloseIcon]="false"  
    [baseZIndex]="1000">
    
    <div class="settings-sidebar-header">
      <h3 class="settings-sidebar-title">Column Settings</h3>
    </div>  
    <div class="settings-sidebar-center">
      <div class="settings-content-container">
        <!-- Search -->
        <div class="settings-search-container">
          <i class="pi pi-search"></i>
          <input 
            type="text"
            class="settings-search-input"
            placeholder="Search" 
            [(ngModel)]="columnSearchTerm"
            (ngModelChange)="searchColumns($event)" />
        </div>
        
        <div class="saved-columns-section" *ngIf="savedColumnSettings.length > 0">
          <div class="saved-columns-header">Saved Columns</div>
          <div class="saved-column-item" *ngFor="let column of savedColumnSettings" (click)="applySavedSettings(column.saved_columns)">
            <span class="saved-column-name">{{column.name}}</span>
            <i class="pi pi-trash saved-column-delete" (click)="$event.stopPropagation(); deleteSavedColumns(column.id)"></i>
          </div>
        </div>
        
        <!-- Column Selection -->
        <div class="settings-columns-section">
          <div class="settings-column-item" *ngFor="let col of _talentpoolCol">
            <div class="column-item-left">
              <!-- <p-checkbox 
                name="category"
                [value]="col"
                [(ngModel)]="checkedColumns"
                [inputId]="col.field">
              </p-checkbox> -->
              <p-checkbox name="category" [value]="col.field" [ngModel]="checkedColumnsFields"
                (ngModelChange)="updateCheckedColumns($event)" [inputId]="col.field">
              </p-checkbox>
              <label [for]="col.field" class="settings-column-label">{{col.header}}</label>
            </div>
            <i class="fas fa-grip-vertical drag-handle"></i>
          </div>
        </div>
        
        <!-- Save Settings Section -->
        <div class="save-settings-section" *ngIf="!displaySaveColumnSettings">
          <div class="save-settings-toggle" (click)="displaySaveColumnSettings = true">
            Save Selected Columns      
          </div>
        </div>
        
        <!-- Save Form -->
        <div class="save-settings-section" *ngIf="displaySaveColumnSettings">
          <form class="save-settings-form" [formGroup]="columnSettings" (ngSubmit)="saveColumnSettings()">
            <input 
              type="text"
              class="save-settings-input"
              placeholder="Enter Column Set Name" 
              formControlName="name">
            <button type="submit" pButton class="save-settings-btn" label="Save"></button>
            <button type="button" pButton class="p-button-text" (click)="clearColumnPreferenceName()">
              <i class="pi pi-times"></i>
            </button>
          </form>
        </div>
      </div>
    </div>
    
    <!-- Footer -->
    <div class="settings-actions">
      <button 
        pButton 
        class="settings-cancel-btn"
        label="Cancel"
        [outlined]="true"
        (click)="showSettingsSidebar = false;clearColumnPreferenceName()">
      </button>
      <button 
        pButton 
        class="settings-apply-btn"
        label="Apply"
        (click)="applySelectedColumns()">
      </button>
    </div>
  </p-drawer>

  <!-- Download Sidebar -->
  <p-drawer   
    styleClass="downloadSidebar talentListDownload"   
    [transitionOptions]="'300ms'"   
    [(visible)]="showDownloadSidebar"   
    [modal]="false"  
    position="right"  
    [showCloseIcon]="false"  
    [baseZIndex]="1000">
    
    <!-- Header -->
    <div class="download-sidebar-header">
      <div class="header-top-row">
        <h3 class="download-sidebar-title">Download Candidate Data</h3>
        <div class="format-toggle">
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'csv'}" (click)="downloadAs = 'csv'">
              <i class="pi pi-check" *ngIf="downloadAs === 'csv'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'csv'">CSV</span>
          </div>
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'excel'}" (click)="downloadAs = 'excel'">
              <i class="pi pi-check" *ngIf="downloadAs === 'excel'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'excel'">EXCEL</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Content Area -->
    <div class="download-sidebar-content">
      <div class="download-columns-section">
        <div class="download-column-item select-all-item">
          <p-checkbox           
            [(ngModel)]="selectAllColumns"           
            (onChange)="toggleSelectAll()"          
            [binary]="true"
            inputId="selectAll">        
          </p-checkbox>        
          <label for="selectAll" class="download-column-label">Select All</label>      
        </div>
        
        <!-- Regular Column Items -->
        <div class="download-column-item" *ngFor="let col of colsToDownload">
          <p-checkbox           
            name="downloadColumns"           
            [value]="col"           
            [(ngModel)]="checkedColumns"           
            [inputId]="col.field"
            (onChange)="onColumnCheckChange()">        
          </p-checkbox>        
          <label [for]="col.field" class="download-column-label">{{col.header}}</label>      
        </div>
      </div>
    </div>
    
    <!-- Action Buttons -->
    <div class="download-actions">
      <div class="download-buttons-row">
        <button         
          pButton         
          class="cancel-btn"         
          label="Cancel"   
          [outlined]="true"      
          (click)="showDownloadSidebar = false">      
        </button>      
        <button         
          pButton         
          class="download-btn"         
          label="Download"         
          [disabled]="checkedColumns.length === 0"        
          (click)="(downloadAs === 'excel') ? exportRole('Excel') : exportRole('csv')">      
        </button>    
      </div>
    </div>
  </p-drawer>

  <!-- Sidebars -->
  <div class="invite-slider" *ngIf="addTalentpoolSlider">
    <p-drawer class="addTalentpool-slider" [(visible)]="addTalentpoolSlider" styleClass="p-drawer-lg"
      [showCloseIcon]="true" position="right" (onHide)="getAllCandidates()">
      <app-invite-candidate (inviteSent)="inviteSent($event)" (bulkInviteSent)="bulkInviteSent($event)"></app-invite-candidate>
    </p-drawer> 
  </div>

  <!-- Move Candidate Dialog -->
  <app-invite-candidate 
    *ngIf="moveCandidateSlider" 
    [existingCandidates]="selectedTalent" 
    [action]="'moveCandidate'"
    (candidateMoved)="candidateMoved($event)"
    (closeAddCandidate)="onCloseMoveCandidate($event)">
  </app-invite-candidate>

  <app-send-email 
    *ngIf="sendEmailSlider" 
    [selectedUsersList]="selectedUsersList" 
    [location]="'talentPool'" 
    (mailSent)="mailSent($event)" 
    [sendMailHeader]="'Send Email'">
  </app-send-email>

  <!-- Filter Tabs Container - Event-list style -->
  <div class="filter-tabs-container">
    <div class="filter-tabs">
      <div class="filter-tab active">
        All Candidates
        <span class="candidate-count">{{ totalLength || 0 }}</span>
      </div>
    </div>

    <!-- Table Controls -->
    <div class="table-controls">
      <button pButton class="control-btn" pTooltip="Column Settings" tooltipPosition="top" (click)="onClickSettingsSidebar()">
        <img src="assets/icons-svg/column-setting.svg" alt="Settings" />
      </button>
      <button pButton class="control-btn" 
              *ngIf="userPrivileges.has('candidate.export')"
              pTooltip="Download" tooltipPosition="top" (click)="showDownloadSidebar = true; showSettingsSidebar = false;">
        <img src="assets/icons-svg/download.svg" alt="Download" />
      </button>
      <button pButton class="control-btn" pTooltip="Refresh" tooltipPosition="top" (click)="getAllCandidates()">
        <img src="assets/icons-svg/refresh.svg" alt="Refresh" />
      </button>
      <span class="table-menu">
        <p-select
        class="view-list-dropdown" 
          [options]="pageLimits" 
          [(ngModel)]="pageSize" 
          (onChange)="getAllCandidates()">
        </p-select>
        <button pButton (click)="prev()" [disabled]="isFirstPage() || loadingSpinner" class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-left.svg" alt="Previous" class="icon-svg">
        </button>
        <button pButton class="disabled p-button-secondary p-button-text simple-btn">{{ loadingSpinner ? '...' : pageNumber + ' of ' + totalPages }}</button>
        <button pButton (click)="next()" [disabled]="isLastPage() || loadingSpinner" class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-right.svg" alt="Next" class="icon-svg">
        </button>
      </span>
    </div>
  </div>

  <!-- Main Table Container -->
  <div class="main-table-container">
    <p-table 
      #dt 
      [columns]="_selectedColumns" 
      [value]="loadingSpinner ? skeletonData : talentList"
      [resizableColumns]="true" 
      [rows]="pageSize" 
      [loading]="false" 
      [scrollable]="true" 
      scrollDirection="both" 
      responsiveLayout="scroll" 
      dataKey="id" 
      [(selection)]="selectedUsersList"
      (selectionChange)="onSelectedTalentChange($event)" 
      [exportFilename]="exportName"
      styleClass="modern-table">
      
      <ng-template pTemplate="header" let-columns>
        <tr class="modern-table-header" [ngClass]="{'moveTable': showSettingsSidebar || showDownloadSidebar}">
          <th scope="col" class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container" *ngIf="!loadingSpinner && talentList?.length">
              <p-tableHeaderCheckbox [disabled]="loadingSpinner"></p-tableHeaderCheckbox>
            </div>
          </th>
          <th class="candidate-name-column" scope="col" pResizableColumn pFrozenColumn>CANDIDATE NAME</th>
          <th [style]="{width: '11vw'}" scope="col" pSortableColumn="{{ col.field }}" *ngFor="let col of columns" pResizableColumn>
            {{ col.header }}
            <p-sortIcon class="sort-icon" field="{{ col.field }}"></p-sortIcon>
          </th>
        </tr>
        
        <!-- Selection operations row -->
        <tr class="selection-operations-row" *ngIf="selectedUsersList.length && !loadingSpinner"
            [ngClass]="{'moveTable': showSettingsSidebar || showDownloadSidebar}">
          <td [attr.colspan]="columns.length + 2" class="selection-operations-options">
            <div class="selection-operations-content">
              <span class="selection-count">{{selectedUsersList.length}} Selected</span>
              <div class="selection-buttons">
                <button pButton 
                        label="Add to Events" 
                        (click)="moveCandidates()"
                        *ngIf="userPrivileges.has('candidate.bulk_action') || userPrivileges.has('candidate.invite')"
                        [style]="{fontWeight: '500'}"
                        [disabled]="selectedUsersList.length === 0">
                </button>
                <button pButton 
                        label="Send Email" 
                        (click)="sendEmail()"
                        [style]="{fontWeight: '500'}"
                        [disabled]="selectedUsersList.length === 0">
                </button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-candidate let-columns="columns">
        <tr class="modern-table-row" 
            [ngClass]="{'moveTable': showSettingsSidebar || showDownloadSidebar, 'skeleton-row': loadingSpinner}" 
            [style]="{cursor: loadingSpinner ? 'default' : 'pointer'}">
          <td class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container">
              <ng-container *ngIf="!loadingSpinner; else skeletonCheckbox">
                <ng-container *ngIf="talentList.length">
                  <p-tableCheckbox [value]="candidate"></p-tableCheckbox>
                </ng-container>
              </ng-container>
              <ng-template #skeletonCheckbox>
                <div class="skeleton skeleton-checkbox"></div>
              </ng-template>
            </div>
          </td>
          <td 
          (click)="!loadingSpinner && openCandidates(candidate)" 
          class="candidate-name-column" 
          pFrozenColumn>
          <ng-container *ngIf="!loadingSpinner; else skeletonText">
            <div class="candidate-info">
              <div class="candidate-avatar" [style.background-color]="getAvatarColor(getFullName(candidate))">
                <!-- Show image if photo URL exists -->
                <img 
                  *ngIf="hasValidPhoto(candidate)"
                  [src]="candidate.photo" 
                  [alt]="getFullName(candidate)"
                  class="candidate-photo"
                  (error)="onImageError($event, candidate)"
                  (load)="onImageLoad($event)" />
                
                <span class="candidate-initials" 
                      [style.display]="hasValidPhoto(candidate) ? 'none' : 'flex'">
                  {{ getInitials(getFullName(candidate)) }}
                </span>
              </div>
              <div class="candidate-details">
                <span class="candidate-name">{{ getFullName(candidate) }}</span>
                <span class="candidate-id" 
                      (click)="$event.stopPropagation(); copyToClipboard(candidate.uuid, 'Candidate ID')"
                      (keydown.enter)="copyToClipboard(candidate.uuid, 'Candidate ID')"
                      (keydown.space)="copyToClipboard(candidate.uuid, 'Candidate ID')"
                      title="Click to copy Candidate ID"
                      role="button"
                      tabindex="0"
                      [attr.aria-label]="'Candidate ID: ' + getTruncatedId(candidate.uuid) + '. Click to copy to clipboard'">
                  {{ getTruncatedId(candidate.uuid) }}
                </span>
              </div>
              
            </div>
          </ng-container>
          <ng-template #skeletonText>
            <div class="skeleton skeleton-text skeleton-text-long"></div>
          </ng-template>
        </td>
          <td *ngFor="let col of columns" 
              (click)="!loadingSpinner && openCandidates(candidate)" 
              [style]="{width: '11vw'}">
            <ng-container *ngIf="!loadingSpinner; else skeletonCell">
              <span [ngSwitch]="true" class="box-data">
                <span *ngSwitchCase="col.field === 'degree'">
                  {{ getEducationInfo(candidate) }}
                </span>
                <span *ngSwitchCase="col.field === 'degree_name'">
                  {{ getDegreeInfo(candidate) }}
                </span>
                <!-- Status Badge -->
                <span *ngSwitchCase="col.field === 'status'" class="modern-status-badge" [ngClass]="getStatusClass(candidate[col.field])">
                  {{ (candidate[col.field] | titlecase) || '-' }}
                </span>

                <!-- Date Fields -->
                <span *ngSwitchCase="col.field === 'createdAt' || col.field === 'date_of_birth'">
                  {{ candidate[col.field] ? (candidate[col.field] | date: dateFormat) : '-' }}
                </span>

                <!-- Event Category -->
                <span *ngSwitchCase="col.field === 'eventCategory'">
                  {{ candidate[col.field] === 'technical' ? 'Technical' : (candidate[col.field] === 'nonTechnical' ? 'Non-Technical' : (candidate[col.field] || '-')) }}
                </span>

                <!-- Email Field -->
                <span *ngSwitchCase="col.field === 'email'">
                  {{ candidate[col.field] || '-' }}
                </span>

                <!-- Default Text -->
                <span [ngClass]="{'capitalize': col.field === 'gender'}" *ngSwitchDefault>
                  {{( candidate[col.field] || '-') | titleCaseUnderscore }}
                </span>
              </span>
            </ng-container>
            <ng-template #skeletonCell>
              <div class="skeleton" [ngClass]="{
                'skeleton-badge': col.field === 'status',
                'skeleton-text': col.field !== 'status' && col.field !== 'events',
                'skeleton-text-short': col.field === 'events' || col.field === 'eventCategory'
              }"></div>
            </ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="_selectedColumns.length + 2" class="empty-message-container">
            <div class="empty-state">
              <div class="empty-state-icon">
                <i class="pi pi-search"></i>
              </div>
              <h3 class="empty-state-title">No Candidates Found</h3>
              <p class="empty-state-description">
                Try adjusting filters or search terms.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>    
    </p-table>
  </div>
</div>

<!-- Candidate Details Sidebar -->
<div *ngIf="displayCandidateDetails">
  <p-drawer class="candidateDetaile" [transitionOptions]="'0ms'" [(visible)]="displayCandidateDetails"
    styleClass="p-drawer-lg" position="right" [style]="{width: '650px'}">
    <ng-container *ngIf="!isCandidateInfoView">
      <app-candidate-basic-info [selectedUser]="selectedUser" (switchToCandidateInfo)="switchToCandidateInfo($event)">
      </app-candidate-basic-info>
    </ng-container>
    <ng-container *ngIf="isCandidateInfoView">
      <app-candidate-info [selectedUser]="selectedUser" [showBackButton]="true"
        (backClicked)="onBackToCandidateBasicInfo()">
      </app-candidate-info>
    </ng-container>
  </p-drawer>
</div>

<p-menu #menu [popup]="true" [model]="talentOptions"></p-menu>